import { IframeInterface } from 'next-common-lib';

export const getShortcutIframeInterface = frameId => {
  const shortcutIframeInterface = new IframeInterface(frameId);
  shortcutIframeInterface.setInterface((action, payload, event) => {
    if (action === 'shortcut') {
      event.stopPropagation();
      event.preventDefault();
    }
  });
  return shortcutIframeInterface;
};
export default {
  getShortcutIframeInterface,
};
